import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FilterListSideFilterComponent } from '../filter-list-side-filter/filter-list-side-filter.component';
import { RenderFilterValueList } from '../types';

@Component({
    selector: 'lib-filter-list-top-filter',
    templateUrl: './filter-list-top-filter.component.html',
    styleUrls: ['./filter-list-top-filter.component.css'],
    standalone: false
})
export class FilterListTopFilterComponent extends FilterListSideFilterComponent implements OnInit, OnChanges {
  dropdownIsOpen = false;

  public checkBoxFilter: RenderFilterValueList;


  ngOnInit(): void {
    super.ngOnInit();
    if (this.renderFilter.type === 'CheckBoxConfigBaseFilter') {
      this.checkBoxFilter = this.renderFilter.valueList.find(option => option.valueId === this.renderFilter.name);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  handleDropdownOpen(isOpen: boolean) {
    this.dropdownIsOpen = isOpen;
  }

  checkboxChange({ target: { checked } }) {
    if (checked) {
      this.selectValue.emit(this.renderFilter.name);
    } else {
      this.deselectValue.emit(this.renderFilter.name);
    }
    this.updateHasSelection()
  }
}
